import { db } from './data_mysqlbase';

// Service spécifique pour les inscriptions
export class RegistrationService {
  async saveRegistration(data) {
    try {
      const registrationData = {
        ...data,
        createdAt: new Date().toISOString(),
        lastModified: new Date().toISOString(),
        status: 'pending',
        notes: ''
      };
      
      const id = await db.registrations.add(registrationData);
      return Number(id);
    } catch (error) {
      console.error('Error saving registration:', error);
      throw new Error('Erreur lors de la sauvegarde des données');
    }
  }

  async getRegistration(id) {
    try {
      return await db.registrations.get(id);
    } catch (error) {
      console.error('Error getting registration:', error);
      throw new Error('Erreur lors de la récupération des données');
    }
  }

  async getAllRegistrations() {
    try {
      return await db.registrations.toArray();
    } catch (error) {
      console.error('Error getting all registrations:', error);
      throw new Error('Erreur lors de la récupération des données');
    }
  }

  async updateRegistrationStatus(id, status) {
    try {
      const registration = await db.registrations.get(id);
      if (!registration) {
        throw new Error('Enregistrement non trouvé');
      }
      await db.registrations.update(id, { 
        status,
        lastModified: new Date().toISOString()
      });
    } catch (error) {
      console.error('Error updating registration status:', error);
      throw new Error('Erreur lors de la mise à jour du statut');
    }
  }

  async deleteRegistration(id) {
    try {
      await db.registrations.delete(id);
    } catch (error) {
      console.error('Error deleting registration:', error);
      throw new Error('Erreur lors de la suppression des données');
    }
  }
}

// Instance unique du service d'inscription
export const registrationService = new RegistrationService(); 